export default __webpack_public_path__ + "static/stacked-area-66246c62c6a3f636b97643fdd47c9406.png";